<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-0">
          <a-row class='py-2'>
            <a-col :sm='24' :lg='15' class='pr-1'>
              <a-input style="width: 100%" placeholder="Buscar..." v-model:value="searchText"
                @keyup.enter="getPlants(10, 0, searchText)" />
            </a-col>
            <a-col :sm='12' :lg='4' class='pl-1'>
              <button style="width: 100%" class="btn bg-holcim-bright-green text-white"
                @click="getPlants(10, 0, searchText)">
                <i class="fe fe-refresh-cw" />
                Buscar
              </button>
            </a-col>
            <a-col :sm='12' :lg='4' class='pl-1'>
              <button class="btn bg-holcim-dark-blue text-white" style="width: 100%" @click='openModal'>
                <i class="fe fe-plus" />
                Nueva Planta
              </button>
            </a-col>
            <a-col :sm='12' :lg='1' class='pl-1'>
              <router-link to="/catalogos/principal" style="width: 100%" class="btn bg-holcim-bright-blue">
                <i class="fe fe-arrow-left" />
              </router-link>
            </a-col>
          </a-row>
        </div>

        <a-modal :closable="false" :visible="visible" title="Registro de Planta">
          <a-form :model="form" ref="ruleForm" :rules="rules" @finish="submit" layout="vertical" label-align="left">
            <a-form-item label="Código de planta:" name="code" required>
              <a-input v-model:value="form.code" placeholder="Código de planta" />
            </a-form-item>

            <a-form-item label="Nombre de planta:" name="name" required>
              <a-input v-model:value="form.name" placeholder="Nombre de planta" />
            </a-form-item>

            <a-form-item label="Unidad de negocio:" name="businessUnit" required>
              <a-select placeholder="Seleccione la unidad de negocio" :value="form.businessUnit" @change="handleChange"
                style="width: 100%">
                <a-select-option v-for="item in selectBusinessUnits" :key="item.id" :value="item.id">
                  {{ item.code }} - {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <error-manager-component v-if="errorHandler.errorDescription.errors.length > 0"
              :errors="errorHandler.errorDescription.errors" />

            <a-row class='py-1'>
              <a-col span="8" offset="10" v-if="formLoad">
                <a-spin tip="Cargando..." />
              </a-col>
              <a-col span="12" class="pt-1 pl-1" offset="6" v-else>
                <button type="submit" style="width: 100%" class="btn bg-holcim-bright-green text-white">
                  <i class="fe fe-save" />
                  Guardar
                </button>
              </a-col>
            </a-row>
          </a-form>

          <template #footer>
            <a-button key="back" @click="closeModal">
              <i class='fe fe-x-circle pr-2' />
              Cerrar
            </a-button>
          </template>
        </a-modal>

        <div class="card-body">
          <plant-table :data="plants" :loading="tableLoading" @openModal="eventOpenModal"
            @softDelete="eventSoftDelete" />
          <a-pagination class="pt-4" v-model="paginatorCurrentPage" :total="paginatorTotalItems"
            @change="onChangePaginator" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PlantTable from './components/PlantTable'
import usePlant from '../../../composables/usePlant'
import ErrorManagerComponent from '../../../components/errorManagerComponent'

export default {
  name: 'PlantIndex',
  components: { ErrorManagerComponent, PlantTable },
  setup() {

    const {
      selectBusinessUnits,

      eventOpenModal,
      eventSoftDelete,

      searchText,
      visible,
      formId,
      form,
      formLoad,
      initialForm,
      rules,
      plants,
      tableLoading,
      errorHandler,
      ruleForm,

      paginatorTotalItems,
      paginatorTotalPages,
      paginatorCurrentPage,
      onChangePaginator,

      openModal,
      closeModal,
      getPlants,
      submit,
      deleteRecord,
      handleChange,
    } = usePlant()

    return {
      selectBusinessUnits,

      eventOpenModal,
      eventSoftDelete,

      searchText,
      visible,
      formId,
      form,
      formLoad,
      initialForm,
      rules,
      plants,
      tableLoading,
      errorHandler,
      ruleForm,

      paginatorTotalItems,
      paginatorTotalPages,
      paginatorCurrentPage,
      onChangePaginator,

      openModal,
      closeModal,
      getPlants,
      submit,
      deleteRecord,
      handleChange,
    }
  },
}
</script>

<style scoped></style>
